import { useState } from 'react';

export default function ReasonButton({ label, placeholder, defaultReason, onSubmit, testid }) {
  const [open, setOpen] = useState(false);
  const [v, setV] = useState(defaultReason);
  if (!open) return <button className="btn-outline whitespace-nowrap py-1 text-xs" onClick={() => setOpen(true)} data-testid={testid}>{label}</button>;
  return (
    <div className="flex min-w-[260px] items-center gap-1">
      <input className="input py-1 text-xs" value={v} placeholder={placeholder} onChange={(e) => setV(e.target.value)} data-testid={`${testid}-reason`} />
      <button className="btn-primary py-1 text-xs" disabled={v.trim().length < 3} data-testid={`${testid}-confirm`} onClick={async () => { if (await onSubmit(v)) setOpen(false); }}>OK</button>
      <button className="btn-ghost py-1 text-xs" onClick={() => setOpen(false)}>✕</button>
    </div>
  );
}
